
<script>
    import { memberStore } from '../../store.js';
    import { navigateTo } from 'svelte-router-spa'
    memberStore.set(null);
    
        dataLayer.push({
            'event':'CustomEvent',
            'category':'Log Out',
            'action':'Log out success',
            'label':'Click'
        });
    
    navigateTo('login') 
</script>


<svelte:head>
    <title>Logout</title>
</svelte:head>

<section>
   
</section>


